import { Cross2Icon } from "@radix-ui/react-icons";
import { Table } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FacetedFilterDef } from "./data-table";
import { DataTableFacetedFilter } from "./data-table-faceted-filter";
import { DataTableViewOptions } from "./data-table-view-options";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
  searchColumn: string;
  searchPlaceholder: string;
  facetedFilters?: FacetedFilterDef[];
}

export function DataTableToolbar<TData>({
  table,
  searchColumn,
  searchPlaceholder,
  facetedFilters,
}: Readonly<DataTableToolbarProps<TData>>) {
  const isFiltered = table.getState().columnFilters.length > 0;

  const handleSearchChange = (
    event: Readonly<React.ChangeEvent<HTMLInputElement>>,
  ) => {
    if (!searchColumn) return;
    table.getColumn(searchColumn)?.setFilterValue(event.target.value);
  };

  return (
    <div className="flex flex-col-reverse items-start justify-between gap-y-2 sm:flex-row sm:items-center">
      <div className="flex flex-1 items-center space-x-2">
        {searchColumn && (
          <Input
            placeholder={searchPlaceholder}
            value={
              (table.getColumn(searchColumn)?.getFilterValue() as string) ?? ""
            }
            onChange={handleSearchChange}
            className="h-8 w-[150px] lg:w-[250px]"
          />
        )}
        {facetedFilters?.map(({ columnId, title, options }) => {
          const column = table.getColumn(columnId);
          if (!column) return null;
          return (
            <DataTableFacetedFilter
              key={columnId}
              column={column}
              title={title}
              options={options}
            />
          );
        })}
        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => table.resetColumnFilters()}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <Cross2Icon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
      <DataTableViewOptions table={table} />
    </div>
  );
}
